import { Button, Text, Textarea } from '@components/ui';
import { useSaveSpecialMessageMutation } from '@lib/api/rating';
import { logError } from '@lib/logError';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import type { SpecialNotesLocationState } from './specialNotesTypes';

const SpecialNotes = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const jobData = (location.state as SpecialNotesLocationState).jobData;
  const saveSpecialMessage = useSaveSpecialMessageMutation();
  const [specialNotes, setSpecialNotes] = useState<string | null>(null);

  const handlePressNext = (): void => {
    saveSpecialMessage.mutate(
      {
        jobId: jobData.id,
        specialMessage: specialNotes,
        active: true,
      },
      {
        onSuccess: () => {
          navigate('/r8tr-rating', { state: { jobData: jobData } });
        },
        onError: (error: unknown) => {
          logError('special notes', error);
        },
      }
    );
  };

  return (
    <Box
      sx={{
        mt: '25px',
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          mt: '30px',
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Grid
          container
          justifyContent="center"
          sx={{ mt: '15px', width: '100%' }}
        >
          <Grid item xs={12} md={8}>
            <Text variant="subtitle" sx={{ fontSize: 18, fontWeight: 700 }}>
              {t('rating.specialNotes')}
            </Text>
            <Textarea
              placeholder={t('common.messagePlaceholder')}
              value={specialNotes ?? ''}
              minRows={4}
              onChange={(event) => setSpecialNotes(event.target.value)}
              sx={{ mt: 1, '& textarea': { resize: 'none' } }}
            />
          </Grid>
        </Grid>

        <Button
          variant="primary"
          disabled={!specialNotes}
          onClick={handlePressNext}
          sx={{
            height: 45,
            width: '20%',
            mt: 2,
            borderRadius: '0px 15px 0px 15px',
            color: 'common.white',
          }}
          loading={saveSpecialMessage.isPending}
        >
          {' '}
          {t('common.next')}
        </Button>
      </Box>
    </Box>
  );
};

export default SpecialNotes;
